module.exports = __webpack_public_path__ + "static/img/重点工程_banner.a16f4f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/重点工程_banner.png
// module id = gobC
// module chunks = 1